

export const CREATE_USER_FORM_CUTTING_PROGRAM = 'CREATE_USER_FORM_CUTTING_PROGRAM';
export const NAVIGATE_CUTTING_PROGRAM_DETAILS = 'NAVIGATE_CUTTING_PROGRAM_DETAILS';

export const FETCH_CUTTING_PROGRAM_REQUEST = 'FETCH_CUTTING_PROGRAM_REQUEST';
export const FETCH_CUTTING_PROGRAM_SUCCESS = 'FETCH_CUTTING_PROGRAM_SUCCESS';
export const FETCH_CUTTING_PROGRAM_FAILURE = 'FETCH_CUTTING_PROGRAM_FAILURE';

export const FETCH_CUTTING_CONSOLIDATED_REPORT_REQUEST = 'FETCH_CUTTING_CONSOLIDATED_REPORT_REQUEST';
export const FETCH_CUTTING_CONSOLIDATED_REPORT_SUCCESS = 'FETCH_CUTTING_CONSOLIDATED_REPORT_SUCCESS';
export const FETCH_CUTTING_CONSOLIDATED_REPORT_FAILURE = 'FETCH_CUTTING_CONSOLIDATED_REPORT_FAILURE';

export const NAVIGATE_CUTTING_DEFAULT = 'NAVIGATE_CUTTING_DEFAULT';

export const CREATE_CUTTING_PROGRAM_REMARKS_DATA = 'CREATE_CUTTING_PROGRAM_REMARKS_DATA';

export const FETCH_CUTTING_INWARD_REQUEST = 'FETCH_CUTTING_INWARD_REQUEST';
export const FETCH_CUTTING_INWARD_SUCCESS = 'FETCH_CUTTING_INWARD_SUCCESS';
export const FETCH_CUTTING_INWARD_FAILURE = 'FETCH_CUTTING_INWARD_FAILURE';

export const FETCH_SALES_ORDER_BY_STYLE_REQUEST = 'FETCH_SALES_ORDER_BY_STYLE_REQUEST';
export const FETCH_SALES_ORDER_BY_STYLE_SUCCESS = 'FETCH_SALES_ORDER_BY_STYLE_SUCCESS';
export const FETCH_SALES_ORDER_BY_STYLE_FAILURE = 'FETCH_SALES_ORDER_BY_STYLE_FAILURE';


export const NAVIGATE_CUTTING_INWARD_DETAILS = 'NAVIGATE_CUTTING_INWARD_DETAILS';

